/* Keep this in sync with bootstrap/variables.less */

import {Color} from '@benchling/nucleus-ui';

import {assert} from 'Asserts';

/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const NEAR_BLACK = Color.GRAY_900;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const GRAY_DARKER = Color.GRAY_700;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const GRAY_SEMIDARK = Color.GRAY_600;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const GRAY_DARK = Color.GRAY_400;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const GRAY = Color.GRAY_300;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const GRAY_LIGHT = Color.GRAY_200;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const GRAY_LIGHTER = Color.GRAY_50;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const WHITE = '#FFFFFF';

// Brand colors
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const BLUE_POWDER_LIGHT = Color.BLUE_100;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const BLUE_POWDER = Color.BLUE_100;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const BLUE_LIGHTEST = Color.BLUE_200;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const BLUE_LIGHTER = Color.BLUE_300;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const BLUE_LIGHT = Color.BLUE_400;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const BLUE_LIGHT_DISABLED = Color.BLUE_200;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const BLUE = Color.BLUE_500;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const BLUE_DARKER = Color.BLUE_600;

/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const RED_POWDER = Color.RED_100;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const RED_LIGHTEST = Color.RED_150;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const RED_LIGHTER = Color.RED_200;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const RED_LIGHT = Color.RED_400;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const RED = Color.RED_500;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const RED_DARK = Color.RED_600;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const RED_DARKER = '#600000';

/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const ORANGE_LIGHTEST = Color.ORANGE_100;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const ORANGE_LIGHTER = Color.ORANGE_200;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const ORANGE_POWDER = Color.ORANGE_300;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const ORANGE_LIGHT = Color.ORANGE_350;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const ORANGE = Color.ORANGE_400;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const ORANGE_DARK = Color.ORANGE_500;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const ORANGE_DARKER = Color.ORANGE_600;

/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const YELLOW_LIGHTEST = Color.YELLOW_100;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const YELLOW_LIGHTER = Color.YELLOW_200;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const YELLOW_LIGHT = Color.YELLOW_300;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const YELLOW = Color.YELLOW_400;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const YELLOW_DARK = Color.YELLOW_500;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const YELLOW_DARKER = Color.YELLOW_600;

/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const GREEN_LIGHTEST = Color.GREEN_100;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const GREEN_LIGHTER = Color.GREEN_200;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const GREEN_LIGHT = Color.GREEN_300;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const GREEN = Color.GREEN_400;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const GREEN_DARK = Color.GREEN_500;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const GREEN_DARKER = Color.GREEN_600;

/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const PURPLE_LIGHTEST = Color.GRAPE_100;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const PURPLE_LIGHTER = Color.GRAPE_200;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const PURPLE_LIGHT = Color.GRAPE_300;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const PURPLE = Color.GRAPE_400;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const PURPLE_DARK = Color.GRAPE_500;

/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const CLOUDS = Color.BRAND_ICE;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const PETER_RIVER = Color.TEAL_400;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const SILVER = Color.GRAY_500;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const POMEGRANATE = Color.PINK_500;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const LIME = Color.LIME_300;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const EMERALD = Color.GREEN_600;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const AMETHYST = Color.GRAPE_400;
/* @deprecated - use tokens from Color.ts in @benchling/nucleus-ui instead */
export const WISTERIA = Color.GRAPE_300;

export function hexToRgbObject(hex: string): {r: number; g: number; b: number} {
  assert(hex.match(/^#?[a-fA-F\d]{6}$/) != null, 'Invalid hex string provided');
  const [r, g, b] = hex.match(/[a-fA-F\d]{2}/g)!.map((x) => parseInt(x, 16));
  return {r, g, b};
}

/**
 * Convert 6-digit hex string to RGBA color.
 * Example usage:  boxShadow: `0px 2px 6px 0px rgba(${hexToRgba(GRAY, 0.7)})`,
 * @link https://stackoverflow.com/a/51564734 (modified)
 */
export function hexToRgba(hex: string, alpha: number = 1): string {
  assert(alpha >= 0 && alpha <= 1, 'Alpha must be between 0 and 1');
  assert(hex.match(/^#?[a-fA-F\d]{6}$/) != null, 'Invalid hex string provided');
  const [r, g, b] = hex.match(/[a-fA-F\d]{2}/g)!.map((x) => parseInt(x, 16));
  return `${r}, ${g}, ${b}, ${alpha}`;
}

/**
 * Convert 6-digit hex string to RGB color.
 * Example: hexToRgb('#FFFFFF') === '255, 255, 255'
 */
export function hexToRgb(hex: string): string {
  const {r, g, b} = hexToRgbObject(hex);
  return `${r}, ${g}, ${b}`;
}
